import isEmpty from 'validator/lib/isEmpty';

export const validateProjectName = (name) => {
  const messages = [];

  if (isEmpty(name, { ignore_whitespace: true })) {
    messages.push('A project name is missing.');
  }

  const valid = messages.length === 0;

  return { valid, messages };
};

export const validateContentTaxonomy = (taxonomyId) => {
  const messages = [];

  if (!taxonomyId) {
    messages.push('Please enter a valid industry or topic');
  }

  const valid = messages.length === 0;
  return { valid, messages };
};
